/**
 * Educational tracks (voies de formation)
 */
export enum Track {
  COLLEGE = 'COLLEGE',
  LYCEE_GENERAL_TECHNO = 'LYCEE_GENERAL_TECHNO',
  LYCEE_GENERAL = 'LYCEE_GENERAL',
  LYCEE_TECHNO = 'LYCEE_TECHNO',
  LYCEE_PRO = 'LYCEE_PRO',
  LYCEE_POLYVALENT = 'LYCEE_POLYVALENT',
  LYCEE_EXP = 'LYCEE_EXP',
  LYCEE_AGRICOLE = 'LYCEE_AGRICOLE',
  LYCEE_MARITIME = 'LYCEE_MARITIME',
}
